import { COLUMN_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';
import { createHyperLinkCell } from './Hyperlink';

export const InvoiceLinkCell = createHyperLinkCell({
    headerName: 'Invoice',
    link: '/sales-invoice-enquiry/invoice-details',
    visibleIf: (data) => !!data.InvoiceNumber,
    getValue: (data) => ({
        SalesEntity: data.SalesEntity,
        InvoiceNumber: data.InvoiceNumber,
        FieldValue: `${data.InvoiceNumber}`,
    }),
});

export const SalesOrderLinkCell = createHyperLinkCell({
    headerName: 'Sales Order',
    link: '/sales-order-enquiry/order-details',
    visibleIf: (data) => !!data.SalesOrder,
    getValue: (data) => ({
        SalesOrder: data.SalesOrder,
        FieldValue: `${data.SalesOrder}`,
    }),
});

export const Transactionscolumns = [
    {
        dataField: 'TransactionDate',
        caption: 'Date',
        width: 120,
        allowSorting: true,
        allowEditing: false,
    },
    {
        dataField: 'SalesEntity',
        caption: 'Entity',
        width: 120
    },
    {
        dataField: 'InvoiceNumber',
        caption: 'Invoice',
        width: 120,
        cellComponent: InvoiceLinkCell,
    },
    {
        dataField: 'TransactionType',
        caption: 'Transaction type',
        width: COLUMN_SIZE.lg1,
    },
    {
        dataField: 'OriginalTotalDisplay',
        caption: 'Original total',
        width: COLUMN_SIZE.md1,
        alignment: 'right'

    },
    {
        dataField: 'AmountDisplay',
        caption: 'Amount',
        width: COLUMN_SIZE.md1,
        allowSorting: false,
        allowEditing: false,
        alignment: 'right',
    },
    {
        dataField: 'Currency',
        caption: 'Currency',
        width: 120,
    },
    {
        dataField: 'Period',
        caption: 'Financial period',
        width: COLUMN_SIZE.md1,
    },
    {
        dataField: 'DueDate',
        caption: 'Due',
        width: COLUMN_SIZE.md1,
    },
    {
        dataField: 'Reference',
        caption: 'Reference',
        width: COLUMN_SIZE.md1,
    },
    {
        dataField: 'GLBatch',
        caption: 'G/L batch',
        width: COLUMN_SIZE.md1,
    },
    {
        dataField: 'LocalOriginalDisplay',
        caption: 'Local original',
        width: COLUMN_SIZE.md1,
        alignment: 'right',
    },
    {
        dataField: 'LocalAmountDisplay',
        caption: 'Local amount',
        width: COLUMN_SIZE.md1,
        alignment: 'right',
    },
];

export const stockingQuantitiesColumns = [
    {
        fixed: true,
        alignment: 'center',
        caption: '',
        minWidth: COLUMN_SIZE.sm1,
        width: COLUMN_SIZE.sm1,
        allowSorting: false,
        allowResizing: false,
        cellComponent: 'InfoCell'
    },
    {
        dataField: 'WarehouseLabel',
        caption: 'Warehouse',
        minWidth: COLUMN_SIZE.md1,
    },
    {
        dataField: 'OnHandQuantityDisplay',
        caption: 'On hand',
        alignment: 'right',
    },
    {
        dataField: 'AllocatedQuantityDisplay',
        caption: 'Allocated',
        alignment: 'right',
    },
    {
        dataField: 'AvailableQuantityDisplay',
        caption: 'Available',
        alignment: 'right',
    },
    {
        dataField: 'WarehouseDescription',
        caption: 'Warehouse name',

    }
];

export const invoicesColumns = [
    {
        dataField: 'SalesEntity',
        caption: 'Entity',
        width: 120
    },
    {
        dataField: 'InvoiceNumber',
        caption: 'Invoice',
        width: 120,
        cellComponent: InvoiceLinkCell,
    },
    {
        dataField: 'TransactionDate',
        caption: 'Date',
        alignment: 'right',
        width: COLUMN_SIZE.md1,
    },
    {
        dataField: 'InvoiceType',
        caption: 'Type',
        width: COLUMN_SIZE.md1,
    },
    {
        dataField: 'InvoiceTotalDisplay',
        caption: 'Invoice total',
        width: COLUMN_SIZE.md1,
        alignment: 'right'

    },
    {
        dataField: 'Currency',
        caption: 'Currency',
        width: 120,
    },
    {
        dataField: 'SalesOrder',
        caption: 'Sales order',
        width: 120,
        cellComponent: SalesOrderLinkCell,
    },
    {
        dataField: 'CustomerPO',
        caption: 'Customer P/O',
        width: COLUMN_SIZE.md1,
    },
    {
        dataField: 'LocalTotalDisplay',
        caption: 'Local total',
        width: COLUMN_SIZE.md1,
    },
    {
        dataField: 'UpdatedDisplay',
        caption: 'Updated',
        width: COLUMN_SIZE.md1,
    }
];

const TransctionsFilterState = {
    EntityView: '',
    Entity: '',
    TransactionType: '',
    TransactionOption: 'Outstanding',
    FromDate: '',
    ToDate: '',
    Invoice: null,
};

const InvoicesFilterState = {
    EntityView: 'MPRO',
    Entity: '',
    TransactionType: 'All',
    TransactionOption: 'Yes',
    FromDate: '',
    ToDate: '',
    CustomerPO: ''
};

export const ProgramConfig = {
    Transactions: {
        columns: Transactionscolumns,
        filterState: TransctionsFilterState,
    },
    Invoices: {
        columns: invoicesColumns,
        filterState: InvoicesFilterState,
    },
    StockingQuantities: {
        columns: stockingQuantitiesColumns,
    }
};

export function getProgramConfig(program: any, type: 'columns' | 'filterState'): any {
    if (!program) return null;

    const config = ProgramConfig[program];
    if (!config) return null;

    return config[type] ?? null;
}

export const getInitialFilterState = (program) => {
    if (!program) return null;

    const map: Record<string, any> = {
        Transactions: TransctionsFilterState,
        Invoices: InvoicesFilterState,
    };

    return map[program] ?? null;
};
